var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"fullscreen-modal"},[(_vm.showCloseButton)?_c('div',{staticClass:"close",on:{"click":_vm.close}},[_c('img',{staticClass:"close-icon",attrs:{"src":require("../../assets/close-icon.png"),"alt":"Close icon"}})]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }